import { clientLogger } from '../logger';

export const handleMissingTranslations = (err: {
  code: string;
  message: string;
}) => {
  // Missing translations fall back to the default (source) message. This is
  // expected for partially-translated locales, so swallow it silently — logging
  // it was generating alarm noise.
  if (err.code === 'MISSING_TRANSLATION') {
    return;
  }
  // Surface genuine intl errors (e.g. malformed ICU syntax) — these are bugs.
  clientLogger.warn(
    { code: err.code, message: err.message },
    '[intl] non-missing-translation error'
  );
};
